<ndt-add-department-view
   [callState]="callState | async"
   [form]="form"
   (create)="onCreate()"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
>
</ndt-add-department-view>
